/**
 * @documental
 * @export Placeholder
 * @name
 * Checkbox.Placeholder
 */

import { FC } from "react";
import { BaseProps } from "../../BaseProps";
import { getBasePropsFromHtmlProps } from "../../utilities/getBasePropsFromHtmlProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import { InputContainerPlaceholder } from "../shared/InputContainer/InputContainerPlaceholder";
import { SharedCheckboxPlaceholder } from "./SharedCheckboxPlaceholder";
import styles from "./styles.module.scss";

/**
 * The `Placeholder` component properties.
 */

export interface PlaceholderProps extends BaseProps {}

/**
 * A loading placeholder for the `Checkbox` component.
 */
export const Placeholder: FC<PlaceholderProps> = (props) => {
  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: [styles.CheckboxPlaceholder, "checkbox", "placeholder"],
    testIdPrefix: "checkbox",
  });

  return (
    <InputContainerPlaceholder {...getBasePropsFromHtmlProps(baseHtmlProps)}>
      <SharedCheckboxPlaceholder />
    </InputContainerPlaceholder>
  );
};
